/* migrated from JSX to TSX by Victor Rybakov, 11 Jan 2018
 * KPI/ThemePreview
 */

//const React = require('react');
//const _ = require('underscore');
import * as React from 'react';

class KpiPreview extends React.Component<
    {
        theme;
    },
    any
> {
    constructor(props) {
        super(props);
        this.state = {
            theme: this.props.theme
        };
    }

    render() {
        var label1Up, label2Up, label1Down, label2Down;

        if (this.props.theme['widget-kpi-show-labels'] !== false) {
            const label1 = <p className="theme-label">{'High Strong Level'}</p>;
            const label2 = <p className="theme-label">{'Sum'}</p>;
            if (this.props.theme['widget-kpi-labels-below'] == true) {
                label1Down = label1;
                label2Down = label2;
            } else {
                label1Up = label1;
                label2Up = label2;
            }
        }

        if (this.props.theme['widget-kpi-alignment'] === 'repeatVertically') {
            return (
                <table className="kpi-table">
                    <tbody>
                        <tr>
                            <td>
                                {label1Up}
                                <p className="theme-value">{'12345'}</p>
                                {label1Down}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                {label2Up}
                                <p className="theme-value">{'665.99'}</p>
                                {label2Down}
                            </td>
                        </tr>
                    </tbody>
                </table>
            );
        } else {
            return (
                <table className="kpi-table">
                    <tbody>
                        <tr>
                            <td>
                                {label1Up}
                                <p className="theme-value">{'12345'}</p>
                                {label1Down}
                            </td>

                            <td>
                                {label2Up}
                                <p className="theme-value">{'665.99'}</p>
                                {label2Down}
                            </td>
                        </tr>
                    </tbody>
                </table>
            );
        }
    }
}

export function ThemePreview(glob, theme) {
    return [
        <div className="widget" key="kpi-widget-preview">
            <div className="widget-inner-container">
                <div className="widget-control-panel">
                    <span>KPI Widget</span>
                    <span className="glyphicon glyphicon-remove remove-button header-button"></span>
                    <span className="glyphicon glyphicon-cog config-button header-button"></span>
                    <span className="glyphicon glyphicon-chevron-down menu-button header-button"></span>
                </div>
                <div className="show-header-button">
                    <span className="glyphicon glyphicon-chevron-down"></span>
                </div>
                <div className="widget-canvas widget-canvas-main">
                    <div className="pdc-widget-kpi">
                        <KpiPreview theme={theme} />
                    </div>
                </div>
            </div>
        </div>
    ];
}
